import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

/**
 * GET Competencias Requeridas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCompetenciasRequeridas = async (params) => {
  try {
    const response = await API.get('/nominas/solicitud-de-contratacion-competencias-requeridas/', { params });
    return { ...response.data, results: formatReceived(response.data.results) };
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Competencias Requeridas
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCompetenciaRequerida = async (values) => {
  try {
    const response = await API.post('/nominas/solicitud-de-contratacion-competencias-requeridas/', values);
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
};

/**
 * PATCH Competencias Requeridas
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCompetenciaRequerida = async (id, values) => {
  try {
    const response = await API.patch(`/nominas/solicitud-de-contratacion-competencias-requeridas/${id}/`, values);
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
};

/**
 * DELETE Competencias Requeridas
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCompetenciaRequerida = async (id) => {
  try {
    const response = await API.delete(`/nominas/solicitud-de-contratacion-competencias-requeridas/${id}/`);
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
};
